var map = {
	"./1.jpg": 4139,
	"./2.jpg": 7692,
	"./3.jpg": 5481,
	"./4.jpg": 9642,
	"./5.jpg": 7927,
	"./6.jpg": 9256,
	"./7.jpg": 6869,
	"./8.jpg": 4230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3943;